import { IPaginationInfo } from 'types/pagination'
import { ETenderType } from 'types/tender'

export enum ECommissionEvaluationStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
}

export type ICommissionEvaluation = {
  id: string
  tenderId: string
  correlationId: string
  tenderName: string
  tenderStatus: ECommissionEvaluationStatus
  lotName: string
  submitterOrganizationName: string
  tenderMethod: ETenderType
  tenderStartTime: string
  tenderFinishTime: string
}

export type ICommissionEvaluations = {
  info: IPaginationInfo
  items: ICommissionEvaluation[]
}
